import React from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../../../constants/colors'
import { onboardingCardSx } from '../steps/stepStyles'

interface OnboardingStepCardProps {
  icon: React.ReactNode
  title: string
  hint?: string
  children: React.ReactNode
}

/** Bordered card holding a step's heading (icon + title + hint) and its fields. */
export const OnboardingStepCard: React.FC<OnboardingStepCardProps> = ({ icon, title, hint, children }) => (
  <Box sx={onboardingCardSx}>
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: hint ? 1 : 2.5 }}>
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: '10px',
          backgroundColor: INTERAX_COLORS.sun20,
          border: `1px solid ${INTERAX_COLORS.sun40}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ fontSize: { xs: 17, sm: 19 }, fontWeight: 700, color: INTERAX_COLORS.white }}>
        {title}
      </Typography>
    </Stack>
    {hint ? (
      <Typography sx={{ fontSize: 14, color: INTERAX_COLORS.thunderGrey, mb: 2.5, lineHeight: 1.5 }}>{hint}</Typography>
    ) : null}
    {children}
  </Box>
)
